import { render, staticRenderFns } from "./StartInfosEdit.vue?vue&type=template&id=672f9e2c&"
import script from "./StartInfosEdit.vue?vue&type=script&lang=js&"
export * from "./StartInfosEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports